"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFC_PATTERN = void 0;
exports.validateRFC = validateRFC;
exports.normalizeRFC = normalizeRFC;
/**
 * Validates RFC (Mexican Tax ID) format
 *
 * Valid formats:
 * - Persona Moral: 3 letters + 6 digits + 3 alphanumeric (e.g., HVP850101AB1)
 * - Persona Física: 4 letters + 6 digits + 3 alphanumeric (e.g., GARC850101AB1)
 *
 * @param value - RFC to validate
 * @returns ValidationResult with isValid flag and optional error message
 */
function validateRFC(value) {
    if (!value || !value.trim()) {
        return { isValid: false, error: 'RFC es requerido' };
    }
    const normalized = value.toUpperCase().trim();
    // Mexican RFC format: 3-4 letters + 6 digits + 3 alphanumeric
    const rfcPattern = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;
    if (!rfcPattern.test(normalized)) {
        return { isValid: false, error: 'RFC inválido. Formato esperado: XXXX000000XXX' };
    }
    return { isValid: true };
}
/**
 * Normalizes RFC to uppercase and trimmed
 *
 * @param value - RFC to normalize
 * @returns Normalized RFC
 */
function normalizeRFC(value) {
    return value.toUpperCase().trim();
}
/**
 * Regex pattern for RFC validation
 * Can be used directly in form libraries that accept regex
 */
exports.RFC_PATTERN = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;
